import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ReportType } from "@enums/report-type";
import { environment } from "@env/environment";
import { IExchangeInfo } from "@models/exchange-info.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ReportsService {
  reportType = ReportType;

  getReport$(path: ReportType, intermediaryId?: string): Observable<unknown> {
    let params = new HttpParams({});
    if (intermediaryId) {
      params = params.append("intermediaryId", intermediaryId);
    }
    if (path.includes(this.reportType.AccountManagement)) {
      const today = new Date().toISOString();
      params = params.append("from", today);
    }
    switch (path) {
      case ReportType.AccountManagement:
        return this.http.get(
          `${environment.BASE_URL}report/accountmanagementreport`,
          { params }
        );
      case ReportType.Advisor:
        return this.http.get(`${environment.BASE_URL}report/advisorreport`);
      case ReportType.Intermediary:
        return this.http.get(
          `${environment.BASE_URL}report/intermediarydumpreport`,
          { params }
        );
      default:
        return this.http.get(`${environment.BASE_URL}report/crmdumpreport`);
    }
  }

  saveReport$(
    path: ReportType,
    exchangeInfo?: Partial<IExchangeInfo>,
    annualDate?: string | number
  ): Observable<unknown> {
    const annualPayload = { year: annualDate };
    if (path === ReportType.AnnualReport) {
      return this.http.post(
        `${environment.BASE_URL}report/createAnnualStatement`,
        annualPayload
      );
    } else {
      return this.http.post(
        `${environment.BASE_URL}report/exchangeinformation`,
        exchangeInfo
      );
    }
  }

  constructor(private http: HttpClient) {}
}
